<template>
  <div class="appearance-block">
    <p class="appearance-block__title title" @click="emit('toggleFilter')">
      Внешность
      <span v-if="searchStore.appearanceFilters" class="title_green">
        Указаны {{ searchStore.appearanceFilters }} параметр
      </span>
      <span v-else class="title_green">Не указаны</span>
      <ArrowIcon
        class="title__arrow"
        :class="{ 'title__arrow_active': visibleFiltersAppearance }"
      />
    </p>

    <transition name="fade-slide">
    <div v-if="visibleFiltersAppearance" class="appearance-block-wrapper">
      <div class="appearance-block__element">
        <p class="appearance-block__title">
          Цвет волос
        </p>
        <pSelect
          class="appearance-block__input"
          :selectionItems="hairColors"
          v-model="searchStore.searchOptions.appearanceInfo.hairColor"
        />
      </div>

      <div class="appearance-block__element">
        <p class="appearance-block__title">
          Интимная стрижка
        </p>
        <pSelect
          class="appearance-block__input"
          :selectionItems="intimHaircuts"
          v-model="searchStore.searchOptions.appearanceInfo.intimHaircut"
        />
      </div>
      <div class="options">
        <pCheckbox
            :modelValue="searchStore.searchOptions.withTattoo"
            label="Татуировки"
            @update:modelValue="searchStore.searchOptions.withTattoo = !searchStore.searchOptions.withTattoo"
        />
        <pCheckbox
            :modelValue="searchStore.searchOptions.withPiercing"
            label="Пирсинг"
            @update:modelValue="searchStore.searchOptions.withPiercing = !searchStore.searchOptions.withPiercing"
        />
        <pCheckbox
            :modelValue="searchStore.searchOptions.withSiliconeBreast"
            label="Силиконовая грудь"
            @update:modelValue="searchStore.searchOptions.withSiliconeBreast = !searchStore.searchOptions.withSiliconeBreast"
        />
      </div>
    </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref, Ref} from 'vue';
import pSelect from '@/common/pSelect/pSelect.vue'
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import { useSearchStore } from "@/searchSection/store/searchStore";
import { IntimHaircut } from "@/searchSection/types/IntimHaircut";
import api from '@/myProfileSection/api';
import HairColorInterface from '@/myProfileSection/types/HairColorInterface';
import ArrowIcon from '@/common/icons/ArrowIcon.vue';


defineProps<{ visibleFiltersAppearance: boolean }>();
const emit = defineEmits(['toggleFilter']);
const searchStore = useSearchStore()

const hairColors: Ref<HairColorInterface[]> = ref([{
  id: 0,
  name: 'Любой',
}]);

onMounted(async () => {
  const hairColorsResponse = await api.getHairColors()
  hairColorsResponse.forEach(c => hairColors.value.push({id: hairColors.value.length, name: c.name}))
})

const intimHaircutDescription = {
  0: 'Любая',
  [IntimHaircut.Neat]: 'Аккуратная стрижка',
  [IntimHaircut.Depilation]: 'Полная депиляция',
  [IntimHaircut.Natural]: 'Натуральная',
}

const intimHaircuts = Object.keys(intimHaircutDescription).map(keyHair => ({
  id: Number(keyHair),
  name: intimHaircutDescription[keyHair]
}))

</script>

<style scoped lang="scss">
.appearance-block {
  &-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    margin-top: 16px;

    @media screen and (max-width: 580px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  &__element {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    grid-column: 1/3;

    @media screen and (max-width: 580px) {
      flex-direction: column;
      align-items: start;
      gap: 15px;
    }
  }
}
</style>